import { Enrollment } from '../../enrollment/enrollment.model';
import { CourseCategory } from './course-category.model';
import { CourseContent } from './course-contents.model';
import { CourseDetails } from './course-details.model';
import { CourseSettings } from './course-settings.model';

export enum CourseStatus {
  DRAFT = 'DRAFT',
  UNDER_REVIEW = 'UNDER_REVIEW',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED',
}

export interface CourseItem {
  _id: string;
  title: string;
  targetAudience?: string;
  subject?: string;
  settings: CourseSettings;
  details: CourseDetails;
  category?: CourseCategory;
  contents: CourseContent[];
  enrollments: Enrollment[];
  status?: string;
}
